import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import 'animate.css/animate.min.css' //引入

import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';

import zhCn from "element-plus/es/locale/lang/zh-cn";

// swiper
import 'swiper/css';


createApp(App).use(store).use(router).use(ElementPlus, { zhCn }).mount('#app');


